@if (open()) {
  <div class="scrim" (click)="close()">
    <div
      class="palette"
      role="dialog"
      aria-modal="true"
      aria-label="Switch organization"
      (click)="$event.stopPropagation()"
    >
      <input
        #search
        type="text"
        class="palette__input"
        placeholder="Search organizations by name or slug"
        aria-label="Search organizations"
        autofocus
        [ngModel]="query()"
        (ngModelChange)="onQueryChange($event)"
      />

      <ul class="palette__list">
        @for (organization of matches(); track organization.slug; let i = $index) {
          <li>
            <button
              type="button"
              class="option"
              [class.option--on]="i === highlighted()"
              (click)="viewAs(organization)"
            >
              <span
                class="option__mark"
                [style.background]="organization.branding.primarySoft"
                [style.color]="organization.branding.ink"
              >{{ organization.displayName.charAt(0) }}</span>
              <span class="option__name">{{ organization.displayName }}</span>
              <span class="option__slug">{{ organization.slug }}</span>
              <span class="option__users">{{ organization.userCount }} users</span>
            </button>
          </li>
        } @empty {
          <li class="palette__empty">No organization matches that.</li>
        }
      </ul>

      <footer class="palette__hint">↑↓ to move · ↵ to view as · Esc to close</footer>
    </div>
  </div>
}
